import React from 'react';
import {GoogleOutlined, FacebookOutlined} from '@ant-design/icons';
import 'firebase/app';
import firebase from 'firebase/app';
import {auth} from '../firebase';

const Login = () => {
    return (
        <div id = "login-page">
            <div id = "login-card">
                <div id="img"></div>
                <h1>Welcome to T Chat &copy;</h1>
                <div
                    className = "login-button google"
                    onClick = {() => auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())}
                >
                    <GoogleOutlined /> Google sign in
                    </div>
                <br/>
                <br/>
                <div 
                    className = "login-button facebook"
                    onClick = {() => auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider())}
                >
                    <FacebookOutlined /> Facebook sign in
                </div>
            </div>
            <div id = "info">
                <ul>
                    <li>
                        About
                    </li>
                    <li>
                
                       <a href="mailto:pcteja2000@gmail.com" >Contact</a>
                    </li>
                    <li>
                        GitHub
                    </li>
                </ul>
            </div>
        </div>
    );
}
export default Login;